import { graphql } from "gql/gql";
import { request } from "graphql-request";

import { BACKEND_DOMAIN } from "utils/constants";
import {
    buildRequestHeaders
} from "utils/helpers";

const queryFn = (
    accessToken: string,
    data: {
        reportFiltersetUid: string | null;
    }
) =>
    request({
        url: `${BACKEND_DOMAIN}/graphql`,
        document: query,
        variables: {
            reportFiltersetUid: data.reportFiltersetUid,
        },    
        requestHeaders: buildRequestHeaders(accessToken),
    }).then(
        (data) =>
            (data.prefilteredReports?.prefilteredRecommendationsReport
                .annualEnergyConsumptionCard as AnnualEnergyConsumptionCardData) ||
            null
    );

const query = graphql(`
    query recommendationsAnnualEnergyConsumptionCard(
        $reportFiltersetUid: Uuid) {
        prefilteredReports(reportFiltersetUid: $reportFiltersetUid) {
            prefilteredRecommendationsReport {
                annualEnergyConsumptionCard {
                    year
                    totalEnergyConsumption
                    totalEnergyConsumptionSavings
                    totalEnergyConsumptionPercentChange
                    averageEnergyIntensity
                    totalEnergyConsumptionNaturalGas
                    totalEnergyConsumptionElectricity
                }
            }
        }
    }
`);

export default queryFn;
